import { InputHTMLAttributes } from "react";
import { useTheme } from "../hooks/useTheme";

interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {

}

export default function InputText (props: InputTextProps) {

    const { theme } = useTheme();

    return (
        <input style={{ outlineColor: theme.color.primary }} {...props} type="text"/>
    );
}